export default "__VITE_ASSET__BAF5HVjm__"